/**
 * mock-connection.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Observable, Subject } from "rxjs/Rx";
import { Message } from "../messages/general/";
import { Connection } from "./connection";

export class MockConnection<T> extends Connection<T> {

  public dead : boolean = false;

  public incoming : Observable<T> = new Subject<T>();

  public sent : T[] = [];

  constructor ()
  {
    super();
  }

  public close () : void
  {
    this.dead = true;
  }

  public send (message : T) : void
  {
    if (!this.dead)
    {
      this.sent.push(message);
    }
  }

  public receive (message : T) : void
  {
    // NOTE: It's up to you to verify if the MockConnection is "dead". I'm not
    // going to verify here because the class is used for testing and should
    // give you freedom to test wrong behavior.
    (this.incoming as Subject<T>).next(message);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/connection/mock-connection.ts